import { render, staticRenderFns } from "./StripePricingGrid.vue?vue&type=template&id=4b532648"
import script from "./StripePricingGrid.vue?vue&type=script&lang=js"
export * from "./StripePricingGrid.vue?vue&type=script&lang=js"
import style0 from "./StripePricingGrid.vue?vue&type=style&index=0&id=4b532648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports